import {Directive, ElementRef, inject, Injector, OnInit, Optional} from "@angular/core";
import { BaseComponent, Parent, IWidgetConfig, provideAsWidgetRef } from '@wm/components-base'
import {LeftPanelComponent} from "../../widgets/page/left-panel/left-panel.component";
import { runtimeEventManager } from '@wm/core';

const DEFAULT_CLS = 'app-left-panel';
const WIDGET_CONFIG: IWidgetConfig = {widgetType: 'wm-left-panel', hostClass: DEFAULT_CLS};

@Directive({
  selector: '[wmLeftPanel]',
  providers: [
    provideAsWidgetRef(LeftPanelDirective)
  ],
  standalone: true,
  exportAs: 'wmLeftPanel',
})
export class LeftPanelDirective extends BaseComponent  implements OnInit {
  private el: JQuery<HTMLElement>;
  private elScope: LeftPanelComponent;

  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    // alert('left panel .. constructor...');
    let elementRef = inject(ElementRef);
    this.el = $(elementRef.nativeElement);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.el.addClass('wm-mobile-app-left-panel');
    let projectService = runtimeEventManager.getService('projectService');
    if (projectService.isTabletApplicationType()) {
      this.el.addClass('wm-tablet-app-left-panel');
    }
  }
}

